export const DESCRIPTION_MAX_LENGTH = 500;

export const validateReportAlert = (alert) => {
	const errors = {};

	if (!alert.title?.trim()) {
		errors.title = 'Alert name is required';
	}

	const description = alert.message || '';

	if (!description.trim()) {
		errors.message = 'Description is required';
	} else if (description.length > DESCRIPTION_MAX_LENGTH) {
		errors.message = `Description must be ${DESCRIPTION_MAX_LENGTH} characters or fewer`;
	}

	const threshold = alert.metric?.threshold;

	if (threshold === null || threshold === undefined) {
		errors.metricThreshold = 'Threshold is required';
	} else if (typeof threshold !== 'number' || Number.isNaN(threshold)) {
		errors.metricThreshold = 'Threshold must be a number';
	}

	if (
		alert.schedule?.frequency === 'weekly' &&
		!alert.schedule?.day_of_week?.trim()
	) {
		errors.dayOfWeek = 'Day of week is required';
	}

	return errors;
};

export const isReportAlertValid = (alert) =>
	Object.keys(validateReportAlert(alert)).length === 0;
